export default "__VITE_ASSET__KBsSEtX0__"